import React, { useEffect, useState } from "react";
import { AiOutlineTable } from "react-icons/ai";
import { MenuItem } from "@mui/material";
import { TextField } from "@mui/material";
import Sidebar from "../../Sidebar/Sidebar";
import { RiAddBoxLine } from "react-icons/ri";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { FaRegFilePdf } from "react-icons/fa";
import DeleteIcon from '@mui/icons-material/Delete';
import { url } from '../../App'
import "../Bureau/Bureau.css";
import Cookies from 'js-cookie';
import PDFViewer from '../Borrower/BorrowerDetails/Components/PDFViewer/PDFViewer'

const Bureau = () => {
  const [open, setOpen] = useState(false);
  const [bureauData, setBureauData] = useState([]);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [rowNumber, setRowNumber] = useState(10);
  var [pageCount, setPageCount] = useState(1);
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const [statusModal, setstatusModal] = useState(false);
  const [bureauEmail, setBureauEmail] = useState("");
  const [bureauAadhaar, setbureauAadhaar] = useState("");
  const [bureauVoterId, setbureauVoterId] = useState("");
  const [bureauName, setbureauName] = useState("");
  const [bureauMobile, setbureauMobile] = useState("");
  const [bureauPullDate, setbureauPullDate] = useState("");
  const [bureauUpdatedPullDate, setbureauUpdatedPullDate] = useState("");
  const [bureauScore, setbureauScore] = useState("");
  const [bureauPdf, setBureauPdf] = useState('')
  const [bureauPan,setBureauPan] =useState("");
  const [bureauId,setBureauId] =useState("");
  const [visible, setvisible] = useState(false);
  const [BureautoBorrowerVisible, setBureautoBorrowerVisible] = useState(false);
  const [DeleteBureauVisible, setDeleteBureauVisible] = useState(false);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          // console.log(res);
          setBureautoBorrowerVisible(res.data[0].permission.bureau_to_borrower);
          setDeleteBureauVisible(res.data[0].permission.delete_bureau);
        })
        .catch((err) => {
          console.log(err);
        })
    };
    setOpen(true);
    axios
      .post(url + "/bureau/getall", {
        token: token,
        email: email,
        pageSize: rowNumber,
        page: pageCount,
      })
      .then((res) => {
        console.log(res)
        setOpen(false);
        if (res.data.auth === true) {
          if (res.data.message.length === 0 && pageCount > 1)
            return setPageCount((pageCount) => pageCount - 1);
          setBureauData(res.data.message)
        }
      })
      .catch((err) => {
        console.log(err);
      });

  }, [token, email, pageCount, rowNumber,]);

  const paginationViewHandler = (e) => {
    parseInt(setRowNumber(e.target.value));
  };

  const getPageLoad = (e) => {
    // setOpen(true);
    if (e === "inc") {
      setPageCount((pageCount) => pageCount + 1);
    } else {
      setPageCount((pageCount) => pageCount - 1);
    }
  }

  const serachDateApi = () => {
    setOpen(true)
    axios
      .post(url + "/bureau/search", {
        token: token,
        email: email,
        borrowerUniqueNo: query
      })
      .then((res) => {
        if (res.data.auth === false) {
          setOpen(false)
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          toast.error(res.data.message);
        } else {
          setOpen(false)
          if (res.data.message.length === 0) return setBureauData([])
          setBureauData(res.data.message);
        }
      })
      .catch((err) => {
        setOpen(false)
        console.log(err);
        toast.error(err.message);
      });
  }

  const handleDeleteBureau = (bureau_id) => {
    console.log(bureau_id, "2")
    let text = `Are you sure you want to delete Bureau ${bureau_id}?`;

    if (window.confirm(text) === true) {
      axios
        .post(url + "/bureau/delete", {
          token: token,
          email: email,
          bureau_id: bureau_id,
        })
        .then((res) => {
          console.log(res);
          if (res.data.auth === true) {
            toast.success(res.data.message);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
            // console.log(res);
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  };

  const fetchBureauReport = async (pdfKey) => {
    console.log(pdfKey, "pdflink")
    try {
      let response = await axios.post(`${url}/bureau/pdf`, {
        leadKeyId: pdfKey
      })
      console.log(response, "pdf");
      setBureauPdf(`data:application/pdf;base64,${response.data.bureauPdf}`)
      console.log(response.data.bureauPdf)
    } catch (err) {
      console.log(err)
      toast.error(err.response.data.message)
    }
  }

  const closePdfViewer = () => {
    setBureauPdf('')
  };

  const toggleModal = (name, mobile, pullDate, updatedPullDate, score, pan, Id) => {
    setstatusModal(!statusModal);
    setbureauName(name);
    setbureauMobile(mobile);
    setbureauPullDate(pullDate);
    setbureauUpdatedPullDate(updatedPullDate);
    setbureauScore(score);
    setBureauPan(pan);
    setBureauId(Id);
  }

  if (statusModal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  const handleSaveData = (e) => {
    e.preventDefault();
    const aadhaarPattern = /^[2-9]{1}[0-9]{11}$/;
    const voterIdPattern = /^[A-Z0-9]{10}$/;

    if (!aadhaarPattern.test(bureauAadhaar)) {
      toast.error("Invalid Aadhaar Number. Please enter a 12-digit valid Aadhaar Number.");
      return;
    }
    if (!voterIdPattern.test(bureauVoterId)) {
      toast.error("Invalid Voter ID. Please enter a 10-character alphanumeric Voter ID.");
      return;
    }
    setstatusModal(!statusModal);
    axios
      .post(url + "/bureau/leadandborrower", {
        token: Cookies.get('Token'),
        email: Cookies.get('Email'),
        bureau_name: bureauName,
        bureau_mobile: bureauMobile,
        bureau_pull_date: bureauPullDate,
        bureau_updated_pull_date: bureauUpdatedPullDate,
        bureau_score: bureauScore,
        bureau_aadhar_no: bureauAadhaar,
        bureau_voter_no: bureauVoterId,
        bureau_email: bureauEmail,
        bureau_pan:bureauPan
      })
      .then((res) => {
        console.log(res);
        if (res.data.auth === false) {
          toast.error(res.data.message);
        } else {
          toast.success(res.data.message);
          axios
        .post(url + "/bureau/delete", {
          token: token,
          email: email,
          bureau_id: bureauId,
        })
        .then((res) => {
          console.log(res);
          if (res.data.auth === true) {
            // toast.success(res.data.message);
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          } else {
             console.log(res);
            // toast.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          // toast.error(err);
        });
        }
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const cancelFunction = () => {
    setstatusModal(!statusModal);
    setbureauAadhaar("")
    setbureauVoterId("")
    setBureauEmail("")
  };

  const abc = (borrowerBirthday) => {
    let newDate = new Date(borrowerBirthday);
    return `${newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate()
      }-${newDate.getMonth() + 1 < 10
        ? "0" + (newDate.getMonth() + 1)
        : newDate.getMonth() + 1
      }-${newDate.getFullYear()}`;
  };

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"Bureau"} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h2 className="main-heading">
              <AiOutlineTable />
              Bureau
            </h2>
            <div className="table-collateral-input-fields">
              <div className="table-head-inputs">
                <TextField
                  placeholder="Bureau Id / Mobile Number"
                  name="search-data"
                  id="search-data"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  variant="outlined"
                  size="small"
                />
              </div>
              <button className="digi-kyc" onClick={serachDateApi}>Search</button>
            </div>
            <div className="lms-table-div">
              <table className="lms-table">
                <thead>
                  <tr>
                    <th>Bureau Id</th>
                    <th>Name</th>
                    <th>Mobile Number</th>
                    <th>Pull Date</th>
                    <th>Score</th>
                    <th>Updated Pull Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {bureauData.length > 0 &&
                    bureauData?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{data.bureau_id}</td>
                          <td>{data.bureau_name.toUpperCase()}</td>
                          <td>{data.bureau_mobile}</td>
                          <td>{abc(data?.bureau_pull_date)}</td>
                          <td>{data?.bureau_score}</td>
                          <td>{abc(data?.bureau_updated_pull_date)}</td>
                          <td className="table-btn-col">
                            {(BureautoBorrowerVisible || visible) && (
                              <button className="table-icon-btn" title="Bureau to Borrower">
                                <RiAddBoxLine style={{ color: "#034ea2" }}
                                  onClick={() => toggleModal(data.bureau_name, data.bureau_mobile, data.bureau_pull_date, data.bureau_updated_pull_date, data.bureau_score, data.bureau_pan, data.bureau_id)} />
                              </button>
                            )}
                            <button className="table-icon-btn" title="Bureau Report">
                              <FaRegFilePdf style={{ color: "green" }}
                                onClick={() => fetchBureauReport(data.bureau_pdf)} />
                            </button>
                            {(DeleteBureauVisible || visible) && (
                              <button className="table-icon-btn" title="Delete">
                                <DeleteIcon style={{ color: "#eb1c24" }}
                                  onClick={() => handleDeleteBureau(data.bureau_id)} />
                              </button>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </div>
            <div className="pagination-div">
              <div className="pagination-select">
                <label>Entries To Display</label>
                <TextField
                  className=""
                  placeholder="rows"
                  select
                  name="created-data"
                  variant="outlined"
                  value={rowNumber}
                  size="small"
                  onChange={paginationViewHandler}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </TextField>
              </div>
              <div className="pagination-bar">
                <button className="digi-kyc" style={{ marginLeft: "1rem" }} onClick={() => getPageLoad("dec")} disabled={pageCount === 1}>Previous</button>
              </div>
              <span className="pageCount" style={{ margin: "1rem" }}>{pageCount}</span>
              <div className="pagination-bar">
                <button className="digi-kyc" onClick={() => getPageLoad("inc")}>Next</button>
              </div>
            </div>
          </div>
          {statusModal && (
            <div className="modal overlay">
              <div className="status-content">
                <h4 style={{ width: "100%", textAlign: "center" }}>
                  Bureau Details
                </h4>
                <br />
                <form onSubmit={handleSaveData}>
                  <div className="lms-table-div-modal">
                    <div className="input-div">
                      <label>Aadhaar Number*</label>
                      <TextField
                        name="aadhaar"
                        type="number"
                        onChange={(e) => setbureauAadhaar(e.target.value)}
                        value={bureauAadhaar}
                        size="small"
                        required
                        placeholder="Aadhaar Number"
                      />
                    </div>
                    <br />
                    <div className="input-div">
                      <label>Voter Id*</label>
                      <TextField
                        name="voterid"
                        onChange={(e) => setbureauVoterId(e.target.value)}
                        value={bureauVoterId}
                        size="small"
                        required
                        placeholder="Voter Id"
                      />
                    </div>
                    <br />
                    <div className="input-div">
                      <label>Email*</label>
                      <TextField
                        name="email"
                        placeholder="Email ID"
                        size="small"
                        required
                        onChange={(e) => setBureauEmail(e.target.value)}
                        value={bureauEmail}
                        type="email"
                      />
                    </div>
                    <br />
                  </div>
                  <button className="save-modal" type="submit">
                    Save
                  </button>
                  <button className="cancel-modal" onClick={cancelFunction}>
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
        <ToastContainer />
        {bureauPdf && (
          <PDFViewer url={bureauPdf} closeModal={closePdfViewer} />
        )}
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default Bureau;